import { Component, OnInit, ViewChild } from '@angular/core';
import { StateService } from '@services/state.service';
import { setTeamNames, sortTeams, unsub } from '@util/utils';
import { DataService } from '@data/data.service';
import { getRowStyle, OrdersGridComponent } from '@grid/orders-grid/orders-grid.component';
import { ToolbarService } from '@toolbar/toolbar.service';
import { BackendPaths } from '@common/backend-paths';
import { NavigationService } from '@services/navigation.service';
import { GridColumnStyles } from '@common/common';
import { TeamDeleteButtonComponent } from '../team-delete-button/team-delete-button.component';
import { TeamService } from '../team.service';
import { Subscription } from 'rxjs';
import { NotificationService } from '@notification/notification.service';

@Component({
  selector: 'app-teams',
  templateUrl: './teams.component.html'
})
export class TeamsComponent implements OnInit {
  changesSub?: Subscription;

  teams: any[] = [];

  gridOptions: any = {
    defaultColDef: {
      cellClass: GridColumnStyles.CELL_CLASS_STRING,
      headerClass: 'def-col',
      autoHeight: true,
    },
    columnDefs: [
      {
        field: 'team_number',
        headerName: 'Nr.',
        width: 60,
        maxWidth: 80,
        cellClass: 'team-number-cell'
      },
      {
        field: 'name',
        headerName: 'Team',
        cellClass: 'team-name-cell',
        minWidth: 120,
        flex: 1
      },
      {
        field: 'mobile',
        headerName: 'Kontakt',
        cellClass: 'team-contact-cell',
        minWidth: 120,
        flex: 1
      },
      {
        cellClass: 'tablan-edit-cell',
        width: 75,
        minWidth: 60,
        cellRenderer: TeamDeleteButtonComponent,
        pinned: 'right'
      }
    ],
    getRowStyle
  };

  private _grid!: OrdersGridComponent;

  @ViewChild('grid', {
    read: OrdersGridComponent
  }) set grid(grid: OrdersGridComponent) {
    this._grid = grid;
    grid && grid.setGridOptions(this.gridOptions);
  }

  constructor(
    private dataService: DataService,
    private navService: NavigationService,
    private notificationService: NotificationService,
    private stateService: StateService,
    private toolbarService: ToolbarService,
    private teamService: TeamService) {
  }

  ngOnInit(): void {
    this.toolbarService.setTitle('Montageteam');

    this.changesSub = this.teamService.changes().subscribe((res: any) => {
      this.getData();
    });
    this.getData();
  }

  ngOnDestroy(): void {
    this.changesSub = unsub(this.changesSub);
  }

  getData() {
    this.dataService.get(BackendPaths.TEAMS).subscribe((response: any) => {
      const data = response?.result;

      if (Array.isArray(data?.rows)) {

        setTeamNames(data.rows);
        sortTeams(data.rows);

        this.stateService.setTeams(data.rows);

        this.teams = data.rows;

        this._grid && this._grid.setRowData(this.teams);
      } else {
        this.notificationService.showErrors([
          'Laden der Daten fehlgeschlagen'
        ]);
      }
    });
  }

  addTeam() {
    return this.navService.goToNewTeam();
  }
}
